import bowser from "bowser";

export const browser = bowser.getParser(window.navigator.userAgent);

export const ie = browser.is("Internet Explorer");
export const ios = browser.is("iOS");
export const safari = browser.is("Safari");
export const iosChrome = browser.satisfies({
  ios: {
    chrome: ">=1"
  }
});
export const iosSafari = browser.satisfies({
  ios: {
    safari: ">=1"
  }
});
export const iosFirefox = browser.satisfies({
  ios: {
    firefox: ">=1"
  }
});
export const macSafari = browser.satisfies({
  macos: {
    safari: ">=1"
  }
});

export const iPadBrowser = ((browser.getOS().name == "macOS") || (browser.getOS().name == "iOS" && browser.getPlatform().type == "tablet")) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;